import { capSQLiteSet } from "@capacitor-community/sqlite";
import { CoreoCollection, CoreoCollectionSortMode } from "../../../types";
import { SyncCollection } from "../app-sync.service";
import { AppDatabaseRepo } from "./base.db";

export interface AppDatabaseCollection {
  id: number;
  projectId: number;
  name: string;
  sortAttributeId: number;
  sortMode: CoreoCollectionSortMode;
  geometric: boolean;
  style: string;
  labelAttributeId: number | null;
  labelSourceType: string | null;
  mapLayer: boolean;
  mapSort: number;
  mapVisible: boolean;
};

export class AppDatabaseCollectionRepo extends AppDatabaseRepo<AppDatabaseCollection, SyncCollection, CoreoCollection> {
  tableName: string = 'collections';

  public toInsertSet(collection: SyncCollection): capSQLiteSet[] {
    return [{
      statement: 'INSERT OR REPLACE INTO collections (id,projectId,name,sortAttributeId,sortMode,geometric,style,labelAttributeId,labelSourceType,mapLayer,mapSort,mapVisible) VALUES (?,?,?,?,?,?,?,?,?,?,?,?)',
      values: [
        collection.id,
        collection.projectId,
        collection.name,
        collection.sortAttributeId,
        collection.sortMode,
        collection.geometric,
        JSON.stringify(collection.style),
        collection.labelAttributeId ?? null,
        collection.labelSourceType ?? null,
        collection.mapLayer,
        collection.mapSort,
        collection.mapVisible
      ]
    }];
  }

  async deserialise(collection: AppDatabaseCollection): Promise<CoreoCollection> {
    return {
      ...collection,
      style: JSON.parse(collection.style),
      labelSourceType: collection.labelSourceType as CoreoCollection['labelSourceType']
    };
  }

  columns = [
    ['id', 'INTEGER NOT NULL'],
    ['projectId', 'INTEGER NOT NULL'],
    ['name', 'TEXT NOT NULL'],
    ['boundingBox', 'TEXT'],
    ['sortAttributeId', 'INTEGER'],
    ['sortMode', 'TEXT'],
    ['geometric', 'INTEGER'],
    ['style', 'TEXT'],
    ['labelAttributeId', 'INTEGER'],
    ['labelSourceType', 'TEXT'],
    ['mapLayer', 'INTEGER'],
    ['mapSort', 'INTEGER'],
    ['mapVisible', 'INTEGER']
  ];
  indexes = [
    'CREATE INDEX IF NOT EXISTS idx_collections_projectId ON collections(projectId)'
  ];
  references = [];
  primaryKey = ["id", "projectId"];


}
